import httpRequest from "services/httpRequest";

const prefix = "/api/note";

export const getNoteList = async params => {
  const result = await httpRequest({
    url: `${prefix}`,
    method: "GET",
    params: params,
  });
  if (result) {
    return result;
  }
  return {};
};
export const getNoteListByCustomer = async params => {
  const result = await httpRequest({
    url: `${prefix}/customer/${params.customerId}`,
    method: "GET",
    // params: params,
  });
  if (result) {
    return result;
  }
  return {};
};

export const getNoteDetail = async params => {
  const result = await httpRequest({
    url: `${prefix}/${params.id}`,
    method: "GET",
    params: params,
  });
  if (result) {
    return result;
  }
  return {};
};

export const addNote = async params => {
  const result = await httpRequest({
    url: `${prefix}`,
    method: "POST",
    data: params,
  });
  return result;
};

export const removeNote = async params => {
  const result = await httpRequest({
    url: `${prefix}/${params.id}`,
    method: "DELETE",
    successMessage: "toast.delete_success",
  });
  return result;
};
